// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import CountryTable from "../../DataTables/MasterData/Country/CountryTable";

// Modals
import CreateCountryModal from "../../UiKits/Modal/MasterData/Country/CreateCountry";

const NationalityContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Country"
        parent="Master Data / Address & Location"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Country Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage country options used throughout the HRIS for employee
                  and applicant personal information.
                </P>
                <CreateCountryModal />
                <CountryTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NationalityContainer;
